<template>
    <div :class="['wrapper', classes]">
        <header class="main-header">
            <!-- Header Navbar -->
            <nav
                class="navbar navbar-static-top navbar2"
                role="navigation">
                <!-- Sidebar toggle button-->
                
                <a href="/">
                    <img
                        src="/static/img/back_home_img.png"
                        alt="Logo"
                        class="img-responsive center-block logo"
                        style="width: 300px; height: 42px; margin-top: 20px; background-color: #3c8dbc;" />
                </a>


                <div class="text-center col-md-10 col-md-offset-2" style="margin-top: -60px;">
                    <div class="row">
                        <div class="text-left col-md-8 col-md-offset-2">
                            <ul class="indexSteps">
                                <li class="indexStepLi">{{$i18n.messages[$i18n.locale].indexProduct}}</li>
                                <li class="indexStepLi">{{$i18n.messages[$i18n.locale].indexNews}}</li>
                                <li class="indexStepLi">
                                    <div class="dropdown">
                                        <a data-toggle="dropdown" href="#">{{$i18n.messages[$i18n.locale].indexResource}}</a>
                                        <ul class="resourceSteps dropdown-menu w100" role="menu" aria-labelledby="dLabel">
                                            <li class="resourceStepLi">
                                                {{$i18n.messages[$i18n.locale].indexDoc}}
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li class="indexStepLi">
                                    <a v-bind:href="forumUrl" target="_new">
                                        {{$i18n.messages[$i18n.locale].indexForum}}
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="text-right col-md-2" style="margin-top: 10px;">
                            <ul class="nav navbar-nav" style="float: right;">
                                <li class="dropdown messages-menu">
                                    <a
                                        href="javascript:;"
                                        class="dropdown-toggle"
                                        data-toggle="dropdown">
                                        <i class="fa fa-language fa-lg"></i>
                                    </a>
                                    <ul class="dropdown-menu" style="width: 70px; min-width: 70px">
                                        <li>
                                            <!-- inner menu: contains the messages -->
                                            <ul class="menu">
                                                <li>
                                                    <a
                                                        href="javascript:;"
                                                        @click="$_admin_dash_change_lang('zh-TW')"
                                                    >
                                                        <h4 style="margin: 0 0 0 0">
                                                            tw
                                                            <i
                                                                v-if="$root.$i18n.locale === 'zh-TW'"
                                                                class="fa fa-check label-success"></i>
                                                        </h4>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        href="javascript:;"
                                                        @click="$_admin_dash_change_lang('en')"
                                                    >
                                                        <h4 style="margin: 0 0 0 0">
                                                            en
                                                            <i
                                                                v-if="$root.$i18n.locale === 'en'"
                                                                class="fa fa-check label-success"></i>
                                                        </h4>
                                                    </a>
                                                </li>
                                                <!-- end message -->
                                            </ul>
                                            <!-- /.menu -->
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
        </header>

        <!-- Content Wrapper. Contains page content -->
        <div class="content-wrapper" style="min-height: 900px; margin-left: 0px">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                <h1>
                    
                </h1>
            </section>

            <div class="container register-table">
                <div class="row vertical-8p">
                    <div class="container">
                        <div class="row">
                            <div class="text-center col-md-10 col-sm-offset-1">
                                <h1 style="">{{$i18n.messages[$i18n.locale].registerTitle}}</h1>
                            </div>
                        </div>
                        <div class="row">
                            <div class="text-center col-md-10 col-sm-offset-1">
                                <ul class="steps"><li class=""><span>1</span>{{$i18n.messages[$i18n.locale].registerFillInfo}}</li><li class="current"><span>2</span>{{$i18n.messages[$i18n.locale].registerComplete}}</li><li class=""><span>3</span>{{$i18n.messages[$i18n.locale].registerFinish}}</li></ul>
                            </div>
                        </div>
                        
                        <div class="text-center col-md-8 col-sm-offset-2">
                            <!-- login form -->
                            <form class="ui form regForm"  @submit.prevent="checkCreds">
                                <div class="box-body">
                                    <div class="form-group" >
                                        <label for="regEmail" class="col-sm-4 control-label">{{$i18n.messages[$i18n.locale].email}}:</label>
                                        <div class="col-sm-4">
                                            <label>{{email}}</label>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="box-body">
                                    <div class="form-group" v-bind:class="{ 'form-group has-error': $v.phone.$invalid }">
                                        <label for="regPhone" class="col-sm-4 control-label">{{$i18n.messages[$i18n.locale].phone}}:</label>
                                        <div class="col-sm-4">
                                            <input class="form-control" id="regPhone" ref="regPhone" name="phone" placeholder="phone" type="text" v-model="phone">
                                        </div>
                                        <label for="regPhone" class="col-sm-4 control-label" v-if="!$v.phone.required">{{$i18n.messages[$i18n.locale].required}}</label>
                                    </div>
                                </div>

                                <div class="box-body">
                                    <div class="form-group" v-bind:class="{ 'form-group has-error': $v.password.$invalid }">
                                        <label for="regPassword" class="col-sm-4 control-label">{{$i18n.messages[$i18n.locale].password}}:</label>
                                        <div class="col-sm-4">
                                            <input class="form-control" id="regPassword" ref="regPassword" name="password" placeholder="password" type="password" v-model="password">
                                        </div>
                                        <label for="regPassword" class="col-sm-4 control-label" v-if="!$v.password.required">{{$i18n.messages[$i18n.locale].required}}</label>
                                        <label for="regPassword" class="col-sm-4 control-label" v-if="!$v.password.minLength">{{$i18n.messages[$i18n.locale].minLength}}</label>
                                    </div>
                                </div>
                                <div class="box-body">
                                    <div class="form-group" v-bind:class="{ 'form-group has-error': $v.confirmPassword.$invalid }">
                                        <label for="regConfirmPassword" class="col-sm-4 control-label">{{$i18n.messages[$i18n.locale].confirmPassword}}:</label>
                                        <div class="col-sm-4">
                                            <input class="form-control" id="regConfirmPassword" ref="regConfirmPassword" name="confirmPassword" placeholder="confirm password" type="password" v-model="confirmPassword">
                                        </div>
                                        <label for="regConfirmPassword" class="col-sm-4 control-label" v-if="!$v.confirmPassword.sameAsPassword">{{$i18n.messages[$i18n.locale].sameAsPassword}}</label>
                                    </div>
                                </div>

                                <div class="box-body">
                                    <div class="form-group">
                                        <label for="regType" class="col-sm-4 control-label">{{$i18n.messages[$i18n.locale].type}}:</label>
                                        <div class="col-sm-4">
                                            <select
                                                id="regType"
                                                v-model="type"
                                                class="form-control"
                                            >
                                                <option value="private">private</option>
                                                <option value="company">company</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="type === 'company'" class="box-body">
                                    <div class="form-group">
                                        <label for="regCompanyName" class="col-sm-4 control-label">{{$i18n.messages[$i18n.locale].companyName}}:</label>
                                        <div class="col-sm-4">
                                            <input class="form-control" id="regCompanyName" ref="regCompanyName" name="companyName" placeholder="companyName" type="text" v-model="companyName">
                                        </div>
                                    </div>
                                </div>

                                <div class="box-body">
                                    <div class="form-group">
                                        <label for="regWantMessage" class="col-sm-4 control-label">{{$i18n.messages[$i18n.locale].wantMessage}}:</label>
                                        <div class="col-sm-4 text-left">
                                            <input
                                                id="regWantMessage"
                                                ref="regWantMessage" 
                                                v-model="wantMessage"
                                                type="checkbox"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <button type="submit" v-bind:class="'btn btn-primary btn-lg margin-top-7px' + loading">Submit</button>
                            </form>
                            <!-- errors -->
                            <div v-if=response class="text-red"><p>{{response}}</p></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /.content-wrapper -->

        <!-- Main Footer -->
        <footer class="main-footer" style="margin-left: 0px">
            <strong>Copyright &copy; {{year}}
                <a href="javascript:;">NUWA Robotics</a>.</strong> All rights reserved.
        </footer>
    </div>


    
</template>

<script>
    import api from '../api'
    import config from '../config'
    import { required, sameAs, minLength } from 'vuelidate/lib/validators'

    export default {
        name: 'Login',
        validations () {
            let data = {
                password: {
                    required,
                    minLength: minLength(6)
                },
                confirmPassword: {
                    sameAsPassword: sameAs('phone')
                },
                phone: {
                    required
                }
            }
            console.log(data)
            return data
        },
        data (router) {
            console.log(router)
            const email = this.$store.state.user ? this.$store.state.user : ''
            const token = this.$store.state.token && this.$store.state.token !== 'null' ? this.$store.state.token : ''
            let protocol = window.location.protocol
            let env = window.location.hostname.split('.')[0]
            let forumPort = env === 'localhost' ? '4567' : '80'
            let port = env === 'localhost' ? '8060' : '80'
            if (protocol === 'https:') {
                forumPort = '443'
                port = '443'
            }
            env = window.location.hostname
            return {
                section: 'Login',
                loading: '',
                year: new Date().getFullYear(),
                lang: '',
                classes: {
                    fixed_layout: config.fixedLayout,
                    hide_logo: config.hideLogoOnMobile
                },
                email: email,
                token: token,
                password: '',
                confirmPassword: '',
                phone: '',
                type: 'private',
                companyName: '',
                response: '',
                wantMessage: true,
                forumUrl: protocol + '//' + env + ':' + forumPort + '/forum/',
                gitbookUrl: protocol + '//' + env + ':' + port + '/gitbook/'
            }
        },
        mounted () {
            this.email = '12233@.com'
            this.$refs.regPhone.focus()
            console.log('==' + this.email)
            console.log(this.$v.confirmPassword.sameAsPassword)
            console.log(this.$v.confirmPassword.$invalid)
        },
        methods: {
            checkCreds () {
                console.log('in')
                const {email, password, phone, type, companyName, wantMessage} = this
                this.toggleLoading()
                this.resetResponse()
                this.$store.commit('TOGGLE_LOADING')
                let body = {email, password, phone, type, wantMessage}
                if (companyName && type === 'company') {
                    body.companyName = companyName
                }
                const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerUserPrefix + config.developerApiRegister + '/' + config.developerApiComplete
                /* Making API call to authenticate a user */
                console.log(path === 'http://dev-api.nuwarobotics.com/v1/developer/user/register/complete')
                console.log(body)
                api.request('post', path, body)
                    .then(response => {
                        this.toggleLoading()
                        console.log('=====')
                        console.log(response.data)
                        var data = response.data.data
                        /* Checking if error object was returned from the server */
                        if (data.error) {
                            var errorName = data.error.name
                            if (errorName) {
                                this.response = errorName === 'InvalidCredentialsError'
                                    ? 'Email/Password incorrect. Please try again.'
                                    : errorName
                            } else {
                                this.response = data.error
                            }

                            return
                        }

                        // var user = data.email
                        // this.$store.commit('SET_USER', user)
                        this.$router.push({name: 'userRegisterComplete'})
                    })
                    .catch(error => {
                        this.$store.commit('TOGGLE_LOADING')
                        console.log(error)
                        if (error.response && error.response.data && error.response.status >= 400) {
                            this.response = 'Please try again.'
                        } else {
                            this.response = 'Server appears to be offline'
                        }
                        this.toggleLoading()
                    })
            },
            toggleLoading () {
                this.loading = (this.loading === '') ? 'loading' : ''
            },
            resetResponse () {
                this.response = ''
            },
            $_admin_dash_change_lang (lang) {
                if (lang) {
                    this.$root.$i18n.locale = lang
                    this.lang = lang
                } else {
                    this.$root.$i18n.locale = this.lang
                }
            }
        }
    }
</script>

<style>
    .register-table {
        height: 100%;
    }
    .register-table {
        display: table;
        color: white;
    }
    .vertical-center-row {
        display: table-cell;
        vertical-align: middle;
    }
    .vertical-20p {
        padding-top: 20%;
    }
    .vertical-10p {
        padding-top: 10%;
    }
    .logo {
        width: 15em;
        padding: 3em;
    }
    .regForm .input-group {
        padding-bottom: 1em;
    }
    .regForm .input-group input, .regForm .input-group select {
        height: 3em;
    }
    .regForm label {
        color: black;
    }
    .regForm .form-group {
        margin-left: -15px;
        margin-right: -15px;
    }
    .control-label {
        padding-top: 7px;
    }
    .margin-top-7px {
        margin-top: 7px;
    }
</style>



// WEBPACK FOOTER //
// UserRegisterFillInfo.vue?5e4c3f03